import { render, staticRenderFns } from "./AuthorizeIntegrationModal.vue?vue&type=template&id=236e40d3&scoped=true&"
import script from "./AuthorizeIntegrationModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizeIntegrationModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeIntegrationModal.vue?vue&type=style&index=0&id=236e40d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e40d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
